export default __webpack_public_path__ + "static/media/healthicons_people-outline.b334f110.svg";